import type { IconName } from '#/components/Icon/IconName';

import type {
  ParticipateDropdownResourcesItemData,
  ParticipateDropdownSearchItemData,
} from './types/ParticipateDropdownData';

export const participateDropdownDataBySearchItemType: Record<
  ParticipateDropdownSearchItemData['type'],
  { iconName: IconName; qaId: string; trackClickedName: string }
> = {
  participate: {
    iconName: 'group',
    qaId: 'nav-how-participate-link',
    trackClickedName: 'How to participate',
  },
  'post-event': {
    iconName: 'pin',
    qaId: 'nav-post-event-link',
    trackClickedName: 'Post an event',
  },
  event: {
    iconName: 'star-calendar',
    qaId: 'nav-browse-events-link',
    trackClickedName: 'Browse events',
  },
};

export const participateDropdownDataByResourcesItemType: Record<
  ParticipateDropdownResourcesItemData['type'],
  { image: string; imageHover: string; qaId: string; trackClickedName: string }
> = {
  blog: {
    image: 'illustrations/article-illustration.svg',
    imageHover: 'illustrations/article-illustration-hover.svg',
    qaId: 'nav-blog-link',
    trackClickedName: 'Blog',
  },
  'recipe-for-action': {
    image: 'illustrations/star-illustration.svg',
    imageHover: 'illustrations/star-illustration-hover.svg',
    qaId: 'nav-recipes-for-action-link',
    trackClickedName: 'Recipes For Action',
  },
  points: {
    image: 'illustrations/announce-illustration.svg',
    imageHover: 'illustrations/announce-illustration-hover.svg',
    qaId: 'nav-get-involved',
    trackClickedName: 'Idealist Points',
  },
};
